export default __webpack_public_path__ + "static/bb-c313beeb1f8adaf4e5ba245c8ac091a1.svg";